import {useBranch} from '../../../../../hooks/routes'
import {getBranchLocator} from '../../../../../rest/locators'
import {defaultBranch} from '../../../../../utils/branchNames'
import type {pipelineHeadFragment$key} from '../../hooks/__generated__/pipelineHeadFragment.graphql'
import {usePipelineHeadId} from '../../hooks/pipeline'

export function useLastRunLocator(pipelineHeadKey: pipelineHeadFragment$key | null) {
  const headId = usePipelineHeadId(pipelineHeadKey)
  const branch = useBranch()

  return [
    `count:1,buildType:(id:${headId}),state:any`,
    getBranchLocator(branch ?? defaultBranch, true),
  ]
    .filter(Boolean)
    .join(',')
}
